export const links = [
  {
    id: "1",
    text: "Home",
    url: "#home",
  },
  {
    id: "2",
    text: "Projects",
    url: "#projects",
  },
  {
    id: "3",
    text: "Skills",
    url: "#skills",
  },
  {
    id: "4",
    text: "About",
    url: "#about",
  },
  {
    id: "5",
    text: "Contacts",
    url: "#contacts",
  },
];

export const EMAIL = "akarshs27@gmail.com";
